import { useChainId, useWatchBlock } from '@lair-finance/wagmi'
import { useLogoutOnWalletDisconnect } from '@/domains/auth/effects/useLogoutOnWalletDisconnect.ts'
import { useResetAuthOnAccountChange } from '@/domains/auth/effects/useResetAuthOnAccountChange.ts'

export function GlobalHooks() {
  const chainId = useChainId()

  useWatchBlock({ chainId, enabled: true })

  useLogoutOnWalletDisconnect()
  useResetAuthOnAccountChange()

  return null
}
